import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { WindowService } from '../window/window.service';

@Injectable()
export class TranslationService {
    public isInitialized = false;
    public readonly defaultLanguageKey = 'en';
    private currentLanguage = new BehaviorSubject<string>(this.defaultLanguageKey);
    public currentLanguage$ = this.currentLanguage.asObservable();
    public constructor(
        private readonly translate: TranslateService,
        private readonly windowService: WindowService,
    ) {
        // configure the translation provider
        this.translate.setDefaultLang(this.defaultLanguageKey);
    }

    public getLanguageKey(): string {
        // disabling all other languages than the default language for now, see https://evorait.atlassian.net/browse/SHP-7312
        // const window = this.windowService.nativeWindow;
        // const lang = window.navigator.languages[0].toLowerCase();
        // return mappedLocales[lang] || this.defaultLanguageKey;
        return this.defaultLanguageKey;
    }

    public setLanguageKey(language: string): void {
        this.translate.use(language);
        this.currentLanguage.next(language);
        this.currentLanguage.complete();
    }
}

// disabling all other languages than the default language for now, see https://evorait.atlassian.net/browse/SHP-7312
// const mappedLocales: { [key: string]: string } = {
//     'en-us': 'en',
//     'en-in': 'en',
//     en: 'en',
//     'de-de': 'de',
//     'de-at': 'de',
//     'de-ch': 'de',
//     de: 'de',
//     'ja-jp': 'en',
//     ja: 'en',
//     'fr-fr': 'fr',
//     fr: 'fr',
//     'it-it': 'it',
//     it: 'it',
// };
